import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MenuPage from "../MenuPage";
import { getPublicTakeawaySettings } from "./takeawayApi";
import "./takeaway.scss";

const TakeawayMenuPage = () => {
  const { restaurant, id } = useParams();
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getPublicTakeawaySettings(id).then(setSettings).catch((requestError) => setError(requestError.message));
  }, [id]);

  if (error) return <TakeawayUnavailable title="Takeaway is unavailable" message={error} />;
  if (!settings) return <div className="public-takeaway-state">Loading takeaway menu...</div>;
  if (!settings.isAvailable) return <TakeawayUnavailable title="Takeaway is unavailable" message="This restaurant has not enabled customer takeaway ordering." />;
  if (!settings.isAcceptingOrders) return <TakeawayUnavailable title="Orders are paused" message="The restaurant is not accepting takeaway orders right now." />;

  return <div className="public-takeaway">
    <div className="public-takeaway-banner">
      <div><strong>Takeaway</strong><span>Ready in about {settings.averagePreparationMinutes} minutes</span></div>
      <Link to={`/${restaurant}/${id}/takeaway/track`}>Track order</Link>
    </div>
    <MenuPage experience="takeaway" />
  </div>;
};

const TakeawayUnavailable = ({ title, message }) => <div className="public-takeaway-state">
  <h1>{title}</h1><p>{message}</p>
</div>;

export default TakeawayMenuPage;
